import { useState } from 'react';
import { CircleUserRound, LogOut, Building2 } from 'lucide-react';
import { useLocalstorageState } from 'rooks';

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { useSelf } from '@/data/user';
import { clearToken, clearTenantId } from '@/helpers/api';

import UserAccountDialog from './UserAccountDialog';

const UserMenu = () => {
  const user = useSelf();
  const [isDarkMode, setIsDarkMode] = useLocalstorageState(`dark-mode`, false);
  const [isAccountDialogOpen, setIsAccountDialogOpen] = useState(false);

  if (user.isLoading || !user.data) {
    return null;
  }

  const handleSignOut = () => {
    clearToken();
    window.location.replace('/login');
  };

  const handleSwitchTenant = () => {
    clearTenantId();
    window.location.replace('/tenant');
  };

  const handleToggleDarkMode = () => {
    setIsDarkMode((prevMode) => !prevMode);
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger>
          <Avatar>
            <AvatarImage
              src=""
              alt={`${user.data.firstname} ${user.data.lastname}`}
            />
            <AvatarFallback>{`${user.data.firstname
              .charAt(0)
              .toUpperCase()}${user.data.lastname
              .charAt(0)
              .toUpperCase()}`}</AvatarFallback>
          </Avatar>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuLabel>
            <p>
              {user.data.firstname} {user.data.lastname}
            </p>
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            onClick={() => setIsAccountDialogOpen(true)}
            className="cursor-pointer"
          >
            <CircleUserRound />
            My Account
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            onClick={handleSwitchTenant}
            className="cursor-pointer"
          >
            <Building2 />
            Switch Tenant
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={handleSignOut} className="cursor-pointer">
            <LogOut />
            Sign Out
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <div className="flex gap-2 items-center p-2">
            <Switch
              id="dark-mode"
              checked={isDarkMode}
              onCheckedChange={handleToggleDarkMode}
            />
            <Label htmlFor="dark-mode" className="font-normal">
              Dark Mode
            </Label>
          </div>
        </DropdownMenuContent>
      </DropdownMenu>
      {isAccountDialogOpen && (
        <UserAccountDialog setOpen={setIsAccountDialogOpen} />
      )}
    </>
  );
};

export default UserMenu;
